/***********************************************
 * For handling out data-hj-suppressed attribute (masking images)
 ***********************************************/

// Constructing styles for image masking.
const constructStyleAttributes = function (suppressedNodeAttrValue, host) {
    const _defaultImageBackgroundUrl = 'https://' + (host || hj.insightsHost) + '/static/app/img/suppressed.png',
        metaStyle = (suppressedNodeAttrValue.meta || {}).style || {},
        width = metaStyle.width,
        height = metaStyle.height,
        newStyleAttributes = [
            suppressedNodeAttrValue.style,
            'background: url("' + _defaultImageBackgroundUrl + '") repeat !important',
            width ? 'width: ' + width : '',
            height ? 'height: ' + height : ''
        ];

    // Ensure any undefined attributes are not returned.
    return newStyleAttributes.filter(function (a) {
        return a;
    });
};

const setSuppressedImageAttributes = function (node, options, host) {
    const _defaultImageSrcUrl = 'https://' + (host || hj.insightsHost) + '/static/app/img/transparent.png',
        newStyleAttributes = constructStyleAttributes(options, host),
        newAttributes = [
            ['src', _defaultImageSrcUrl],
            ['style', newStyleAttributes.join(';')]
        ];

    newAttributes.forEach(function (attr) {
        node.setAttribute(attr[0], attr[1]);
    });
};

/**
 * Wraps setAttribute that checks if node has data-hj-suppressed,
 * and if it does - instead of going through node.setAttribute -
 * it reconstructs src and style attributes.
 *
 * Used in playbacks(recordings) and when sending dpc.
 *
 * @function dataSuppressedSetAttribute
 * @example dataSuppressedSetAttribute(node.setAttribute)
 * @param {function} func: The function to wrap
 * @return {function}: returns wrapped (setAttribute) function
 */
export const dataSuppressedSetAttribute = function wrapSetAttribute(func, host) {
    return function (node, attribute, value) {
        // Ensure that suppressed images are shown with placeholder.
        if (attribute === 'data-hj-suppressed' && typeof value === 'object') {
            setSuppressedImageAttributes(node, value, host);
            return true;
        }
        return func(node, attribute, value);
    };
};
